import { Menu as MenuComponent } from '@mantine/core'

import classNames from './menu.module.css'

export const Menu = MenuComponent.extend({
  defaultProps: {
    position: 'bottom-start',
  },
  classNames,
})
